export function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <p>
          Desenvolvido por Teko Blue Ltda
        </p>
      </div>
    </footer>
  );
}
